const notifications = NOTIFICATION_CONFIG;
export default notifications;
